import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EditOrderService } from '../../../services/edit-order.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'common-edit-order-final-message',
  templateUrl: './edit-order-final-message.component.html',
  styleUrls: ['./edit-order-final-message.component.scss'],
})
export class EditOrderFinalMessageComponent implements OnInit, OnDestroy {
  @Input() text = '';
  @Input() index!: number;
  ready = false;

  //Subscription
  indexChangeSub?: Subscription;

  constructor(private editOrderService: EditOrderService) {}

  ngOnInit() {
    this.indexChangeSub = this.editOrderService.afterIndexChange$.subscribe((val) => {
      if (val === this.index) {
        this.editOrderService.emitTitle.emit('');
        this.editOrderService.hideBackArrow.emit(true);
        this.editOrderService.hideCloseButton.emit(false);
        setTimeout(() => {
          this.ready = true;
        }, 500);
        setTimeout(() => {
          this.editOrderService.closeMenu.emit();
        }, 3000);
      } else {
        this.ready = false;
      }
    });
  }

  ngOnDestroy() {
    this.indexChangeSub?.unsubscribe();
  }
}
